// Severity → dot/background classes. Shared by the TopBar popover and the
// Notifications page so they never drift. Keyed on the backend's uppercase
// NotificationType (INFO | WARNING | ERROR).
export const NOTIFICATION_TYPE_STYLES: Record<string, { dot: string; bg: string }> = {
  ERROR: { dot: 'bg-red-500', bg: 'bg-red-50' },
  WARNING: { dot: 'bg-amber-500', bg: 'bg-amber-50' },
  INFO: { dot: 'bg-blue-500', bg: 'bg-blue-50' },
}

export function typeStyle(type: string): { dot: string; bg: string } {
  return NOTIFICATION_TYPE_STYLES[type] ?? NOTIFICATION_TYPE_STYLES.INFO
}

// Unread badge caps. Shared by the TopBar bell and the dashboard side-nav badges
// so the two surfaces can never disagree once the count reaches double digits.
export function formatBadgeCount(n: number): string {
  return n > 9 ? '9+' : String(n)
}
